import { render, staticRenderFns } from "./ResetSenha.vue?vue&type=template&id=1e1d133e"
import script from "./ResetSenha.vue?vue&type=script&lang=js"
export * from "./ResetSenha.vue?vue&type=script&lang=js"
import style0 from "./ResetSenha.vue?vue&type=style&index=0&id=1e1d133e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports